//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'GFR_Schwartz',
  data() {
    return {
      defaultJson:{
        "Height": "身高",
        "Serum Creatinine": "血肌酐",
        "eGFR": "eGFR"
      },
      form:{
        h:'',
        c:'',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'男'},
        {value:"5",name:'女'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {  
        // 0.413*h/c
        let result = 0.413* form.h / form.c
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/GFRSchwartz.vue